import Manager from "./Manager";
import dayjs, { Dayjs } from "dayjs";
import EventStatusEnum from "../enums/EventStatusEnum";

export default class EventCommunityPresence {
    public id: string
    public status: EventStatusEnum
    public date: string
    public time: string
    public duration: number
    public createdAt: Dayjs
    public users: Manager[]

    constructor(data: any) {
        this.date = data.date
        this.time = data.time
        this.id = data.reference
        this.duration = data.duration
        this.createdAt = dayjs(data.createdAt)
        this.status = EventStatusEnum.tryParse(data.status)
        this.users = data.users ? data.users.map((u: any) => new Manager(u)) : [];
    }
}
